import api from './api';

const reportService = {
  getSales: async (params = {}) => {
    const response = await api.get('/reports/sales', { params });
    return response.data;
  },

  getInventory: async () => {
    const response = await api.get('/reports/inventory');
    return response.data;
  },

  getAccounting: async (params = {}) => {
    const response = await api.get('/reports/accounting', { params });
    return response.data;
  },

  getReceivables: async () => {
    const response = await api.get('/reports/receivables');
    return response.data;
  },

  getCommissions: async (params = {}) => {
    const response = await api.get('/reports/commissions', { params });
    return response.data;
  },

  getNcf: async (params = {}) => {
    const response = await api.get('/reports/ncf', { params });
    return response.data;
  },
};

export default reportService;
